import { DocumentViewMode } from "~/types/enums/DocumentViewMode.enum";

export const useGenerateDocumentPath = (
  submittedDocument: SubmittedDocument,
  mode: DocumentViewMode,
  isAutoReturnEnabled: boolean = true
): string | undefined => {
  if (mode == DocumentViewMode.student) {
    // If we're in student mode and the document is not graded or in student review
    // Then it doesn't matter if the teacher returned it or not.
    // -- This might change if we allow a teacher to return documents that are ungraded.
    if (
      [
        DocumentState.graded,
        DocumentState.studentReview,
        DocumentState.editing,
      ].includes(submittedDocument.state) != true
    ) {
      return undefined;
    }

    // If auto return is not enabled and the document has not been marked as returned
    // Then we do not allow the student to view it.
    if (
      submittedDocument.state == DocumentState.graded &&
      isAutoReturnEnabled != true &&
      submittedDocument.isReturnedToStudent != true
    ) {
      return undefined;
    }
  }

  if (mode == DocumentViewMode.teacher) {
    if (useCanGradeDocument(submittedDocument, mode) == false) return undefined;

    if([DocumentState.draft, DocumentState.editing, DocumentState.studentReview].includes(submittedDocument.state)) {
      return undefined;
    }
  }

  return useIsDocumentReadyToGrade(submittedDocument)
    ? `/documents/${mode}/review/${submittedDocument.id}`
    : undefined;
};
